import { useEffect, useRef } from 'react'

// Dev convenience for iterating on the thank-you page without going
// through the whole form flow each time. When a staff user is on the
// page, posting `'simulateDonation'` to the window from the console
// (`postMessage('simulateDonation', location.origin)`) triggers the
// onSimulate callback with a fake donation result. Origin check keeps
// any random page on the internet from triggering it.
//
// We pull amount/currency/email from the live donation hook (via ref so
// the listener captures latest values without re-attaching every render),
// so simulating after entering data on the form uses the entered values.
// Defaults kick in when simulating on a fresh form load.

const useSimulatedDonation = ({ session, donation, partnerItem, onSimulate }) => {
  const ctx = useRef()
  ctx.current = { donation, partnerItem, onSimulate }

  useEffect(() => {
    if (!session.staff) return

    const handleMessage = e => {
      if (e.origin != location.origin) return
      if (e.data != 'simulateDonation') return

      const { donation, partnerItem, onSimulate } = ctx.current
      onSimulate({
        token: btoa(Math.random().toString().slice(2, 14)),
        paymentMethod: 'credit_card',
        simulated: true,
        partnerItem,
        amount:   donation.state.amount || '50.00',
        currency: donation.currency,
        email:    donation.state.email || 'donor@example.com',
      })
    }

    addEventListener('message', handleMessage)
    return () => removeEventListener('message', handleMessage)
  }, [])
}

export default useSimulatedDonation
